// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__4jgc4","title":"Images90_title__2flBZ","images":"Images90_images__1yrXo"};